import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';

import Datatable, { RELOAD_TABLE_TIME } from '../../components/Datatable/';

import {
  getAllPABXs,
  removePABXs,
  restorePABXs
} from '../../redux/actions/pabxs';
import TableHeader from '../../components/TableHeader';
import ModalRemoveItem from '../../components/ModalRemoveItem';
import ModalRestoreItem from '../../components/ModalRestoreItem';
import searchForPermissions from '../../utils/searchForPermissions';

function List (props) {
  const pabxs = useSelector(state => state.pabxs);
  const dispatch = useDispatch();
  const sessionUser = useSelector(state => state.authentications.user);
  const currentPermissions = searchForPermissions(
    'submenu',
    props.match.path,
    sessionUser.permissionsGroup.permissions
  );
  const [showTable, setShowTable] = useState(true);
  useEffect(() => {
    if (showTable) {
      setShowTable(false);
      setTimeout(() => setShowTable(true), RELOAD_TABLE_TIME);
    }
  }, [currentPermissions.options]);
  const tableData = pabxs.data.filter(
    item => item.active || currentPermissions.options.r
  );
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removePABXs(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restorePABXs({ _id: id, active: true }));
  };

  useEffect(() => {
    dispatch(getAllPABXs());
  }, [dispatch]);

  const columns = [
    {
      title: 'Nome',
      data: 'name',
      render: data => data || '---'
    },
    {
      title: 'Departamento',
      data: 'department.name',
      render: data => data || '---'
    },
    {
      title: 'Ext. Supervisor',
      data: 'supervisorDevice',
      render: data => data || '---'
    },
    {
      title: 'Fabricante',
      data: 'manufacturer',
      render: data => data || '---'
    },
    {
      title: 'Modelo',
      data: 'model',
      render: data => data || '---'
    },
    {
      title: 'IP',
      data: 'ip',
      render: data => data || '---'
    },
    {
      title: 'Porta',
      data: 'port',
      render: data => data || '---'
    },
    {
      title: 'Qtd. Ramais',
      data: 'extensions',
      render: data => data || '---'
    },
    {
      title: 'Qtd. Grupos',
      data: 'groups',
      render: data => data || '---'
    },
    {
      title: 'Qtd. OGM',
      data: 'ogms',
      render: data => data || '---'
    },
    {
      title: 'Qtd. Troncos',
      data: 'networks',
      render: data => data || '---'
    },
    {
      title: 'Cód. Área',
      data: 'localCode',
      render: data => data || '---'
    },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `
          <div class="btn-group">
          ${
            !(currentPermissions.options.l && currentPermissions.options.u)
              ? ''
              : `<button id="${data}" type="button" title="Editar" class="btn btn-warning button-action button-action-update rounded"><i class="fa fa-edit"></i></button>`
          }
          ${
            !obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.d)
              ? ''
              : `<button id="${data}" type="button" title="Excluir" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
          }
          ${
            obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.r)
              ? ''
              : `<button id="${data}" type="button" title="Restaurar" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
          }
          </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const url = '/pabxs/edit/' + id;
    dispatch(push(url));
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(dataRow.name);
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(dataRow.name);
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  return (
    <div className="container-fluid">
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir o PABX'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar o PABX'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <TableHeader
        title={'PABX'}
        url={'/pabxs/add'}
        updateList={() => dispatch(getAllPABXs())}
        isFetching={pabxs.isFetching}
        hideAddButton={!currentPermissions.options.c}
        hideUpdateButton={!currentPermissions.options.l}
      />
      {showTable && currentPermissions.options.l && (
        <Datatable
          data={tableData}
          columns={columns}
          buttons={buttons}
          handleUpdateButton={handleUpdateButton}
          handleDeleteButton={handleDeleteButton}
          handleRestoreButton={handleRestoreButton}
        />
      )}
    </div>
  );
}

List.propTypes = {
  match: PropTypes.object
};

export default List;
